import type {FormRequest} from 'src/api/ProactApiClient';

/** The "Save & <transition>" a queued create replays once it syncs. */
export interface QueuedTransition {
  name: string;
}

export type OfflineFormCreateRequest = FormRequest & {
  queuedTransition?: QueuedTransition;
};

// Outbox-only field — the create endpoint must never receive it.
export const stripQueuedTransition = (
  request: OfflineFormCreateRequest
): FormRequest => {
  const {queuedTransition: _queuedTransition, ...rest} = request;
  return rest as FormRequest;
};
